import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";

import TripsView from "../../../containers/pages/trips-view";

class PagesTripView extends Component {
 
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.trip-view" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        
        <TripsView />

      </Fragment>
    );
  }
}

export default PagesTripView;
